<div class="search-wrapper">
  <mat-form-field appearance="outline" class="search-input">
    <mat-label>Search students</mat-label>
    <input
      matInput
      [(ngModel)]="searchText"
      placeholder="Search by Previous registration or Current Registration"
    />
  </mat-form-field>

  <button mat-flat-button color="primary" (click)="applyFilter()" class="search-btn">
    Search
  </button>
</div>

<div>
    <mat-card>
      <mat-card-title class="title-center">Course Change List</mat-card-title>
    
      <div class="outer-scroll-wrapper">
        <div class="inner-scroll-container mat-elevation-z8">
          <table mat-table [dataSource]="course_change_list" class="full-width-table">
            
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let branch">
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon><b>⋮</b></mat-icon>
                  </button>
              
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item>
                      <mat-icon>edit</mat-icon>
                      <span>Edit</span>
                    </button>
                    <button mat-menu-item>
                      <mat-icon>delete</mat-icon>
                      <span>Delete</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
    
            <ng-container matColumnDef="sno">
              <th mat-header-cell *matHeaderCellDef> S.No. </th>
              <td mat-cell *matCellDef="let row; let i = index">
                {{ currentPage + i + 1 }}
              </td>
            </ng-container>
    
            <!-- Define columns -->
            <ng-container matColumnDef="student_name">
                <th mat-header-cell *matHeaderCellDef> student Name </th>
                <td mat-cell *matCellDef="let s"> {{ s.student?.name }} </td>
              </ng-container>

            <!-- <ng-container matColumnDef="student_id">
              <th mat-header-cell *matHeaderCellDef> student Id </th>
              <td mat-cell *matCellDef="let s"> {{ s.student_id }} </td>
            </ng-container> -->
  
            <ng-container matColumnDef="previous_register_number">
              <th mat-header-cell *matHeaderCellDef> Previous registration </th>
              <td mat-cell *matCellDef="let s"> {{ s.previous_register_number }} </td>
            </ng-container>
    
            <ng-container matColumnDef="current_register_number">
              <th mat-header-cell *matHeaderCellDef> Current Registration </th>
              <td mat-cell *matCellDef="let s"> {{ s.current_register_number }} </td>
            </ng-container>
    
            <ng-container matColumnDef="previous_course">
              <th mat-header-cell *matHeaderCellDef> Previous Course </th>
              <td mat-cell *matCellDef="let s"> {{ s.previous_course.name }} </td>
            </ng-container>
    
            <ng-container matColumnDef="current_course">
              <th mat-header-cell *matHeaderCellDef> Current Course </th>
              <td mat-cell *matCellDef="let s"> {{ s.current_course.name }} </td>
            </ng-container>
    
            <!-- Header and Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </div>
      <mat-paginator
                [pageSizeOptions]="[5, 10, 15, 20]"
                [length]="pagination.length"
                [pageIndex]="pagination.page - 1"
                [pageSize]="pagination.limit"
                (page)="pageEvent($event)"
                *ngIf="pagination.length">
    </mat-paginator>
    </mat-card>
  </div>